module.exports = __webpack_public_path__ + "img/IMG_1039_L.d5acfbf6.webp";